import { render } from "./infoPresencas.vue?vue&type=template&id=138477cc&scoped=true"
import script from "./infoPresencas.vue?vue&type=script&lang=js"
export * from "./infoPresencas.vue?vue&type=script&lang=js"

import "./infoPresencas.vue?vue&type=style&index=0&id=138477cc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-138477cc"]])

export default __exports__